export type ClubContextType = {
    links: ClubLinksType;
    serverSide: boolean;
};

export enum ClubLink {
    CART,
    CUSTOMER_ACCOUNT,
    CUSTOMER_ACCOUNT_CREATE_INVITATION,
    CUSTOMER_ACCOUNT_HEADERDATA,
    CUSTOMER_ORDER,
    CUSTOMER_NEWSLETTER,
    CUSTOMER_NOTIFICATIONS,
    HELPCENTER,
    LOGOUT,
    CAMPAIGN,
    CAMPAIGN_UPCOMING,
    CART_REQUEST,
    CUSTOMER_COUPON,
}

export type ClubLinksType = { [key in ClubLink]: { path: string } };
